export default {
    FULLNAME_PLACEHOLDER:'As it appears in their passport',
    FULLNAME:'Full legal name',
    COMPANY:'Company',
    NAME:'Company name',
    NAME_PLACEHOLDER:'As shown in their certificate of incorporation'
}